import { Theme, themeBreakpoints } from '@/app'
import { useMediaQuery } from '@codeleap/web'

/**
 * These deliberately keep `useMediaQuery`'s default `getInitialValueInEffect: true`.
 *
 * With it false, the first client render reads `matchMedia` while the server-rendered HTML
 * was produced without one, so the two disagree and React discards the whole tree and
 * re-renders it on the client (#418, then #423). Gatsby's `RouteUpdates` mounts twice as a
 * result, which is why every page view was reported to Segment twice on narrow viewports.
 *
 * Nothing is slower for it: the hook's effect calls `setMatches` unconditionally, so the
 * real value still lands one tick after hydration. The flash of the desktop layout comes
 * from the server-rendered HTML either way — only a CSS media query avoids that, and only
 * where the difference is styling rather than a different component.
 */
export const useIsMobile = () => {
  const mediaQuery = Theme.media.down('small')

  const isMobile = useMediaQuery(mediaQuery)

  return isMobile
}

export const useIsTablet = () => {
  const mediaQuery = Theme.media.down('mid')

  const isTablet = useMediaQuery(mediaQuery)

  return isTablet
}

type Breakpoints = keyof typeof themeBreakpoints

export const useMediaQueryDown = (breakpoint: Breakpoints) => {
  const mediaQuery = Theme.media.down(breakpoint)

  const isMobile = useMediaQuery(mediaQuery)

  return isMobile
}
